import {
  Autocomplete,
  Button,
  CardContent,
  Chip,
  Divider,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { IconCheck, IconPlus, IconX } from "@tabler/icons";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import AssignDriver_VehicleService from "src/service/assigndriverService";
import vehicleProfileService from "src/service/vehicleProfile";
import swal from "sweetalert";
import * as yup from "yup";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import VehicleDetailsService from "src/service/vehicleDetails";

const AssignVehicle = () => {
  const validationSchema = yup.object({
    driver_id: yup.string("Select Driver").required("Driver is required"),
  });

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();
  // alert(param.id);

  const [alloted_vehicle_data, setAlloted_vehicle_data] = useState([]);
  const [vehicle_list, setVehicle_list] = useState([]);
  const [showForm, setShowForm] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [showEditButton, setShowEditButton] = useState(false);

  const fetch_vehicle_data = async () => {
    try {
      const res = await vehicleProfileService.fetch_vehicle_alloted_data({
        driver_id: param.id,
      });

      setAlloted_vehicle_data(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_vehicle_list = async () => {
    try {
      const res = await VehicleDetailsService.getVehicleDetails({});
      const vehicle = res.data.filter(
        (driver) =>
          !alloted_vehicle_data.some(
            (item) => item.vehicle_no === driver.vehicle_no
          )
      );
      setVehicle_list(vehicle);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_vehicle_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const handleCancel = () => {
    setShowForm(false);
    setShowEditButton(true);
  };

  const handleEdit = () => {
    setShowForm(true);
    setShowEditButton(false);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      fetch_vehicle_list();
    }, 1000);

    return () => clearTimeout(timerId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alloted_vehicle_data]);

  const initialValues = {
    driver_id: param.id,
    vehicle_no: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));
        try {
          const res = await AssignDriver_VehicleService.addAssignDriver(values);
          swal("success", res.message, "success");
          values.vehicle_no = "";
          fetch_vehicle_data();
          setShowForm(false);
          setShowEditButton(true);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  const deleteAssignDriver = async (id) => {
    swal({
      title: "Delete Assign vehicle",
      text: "Are you sure you want to delete assigned Vehicle?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await AssignDriver_VehicleService.deleteassignDriver(
            {
              id: id,
              d_by: sessionData.data.id,
            }
          );
          if (response.status === 200) {
            swal("success", response.message, "success");

            fetch_vehicle_data();
            setShowForm(false);
            setShowEditButton(true);
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };
  return (
    <>
      <CardContent>
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h4"
            >
              Vehicle Assignment
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {alloted_vehicle_data.length === 0 ? (
              <CardContent>
                <>
                  <Typography
                    style={{ fontSize: "13px", textAlign: "center" }}
                    variant="h6"
                    sx={{ color: "red" }}
                  >
                    No Vehicle Assigned!!
                  </Typography>
                </>
              </CardContent>
            ) : (
              <CardContent>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                  {alloted_vehicle_data.map((item, index) => (
                    <Chip
                      key={index}
                      variant="outlined"
                      color="primary"
                      onDelete={() => deleteAssignDriver(item.id)}
                      label={`${item?.vehicle_no} - ${item?.vehicle_name} `}
                    />
                  ))}
                </div>
              </CardContent>
            )}
          </Grid>
        </Grid>
        <Grid container alignItems="center">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {!showForm && (
              <Tooltip title="Add Driver">
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    border: "none",
                    borderRadius: "30px",
                    cursor: "pointer",
                    opacity: "0.9",
                    float: "right",
                  }}
                  onClick={handleEdit}
                >
                  <IconPlus />
                </Button>
              </Tooltip>
            )}
          </Grid>
        </Grid>

        {/* ============================= */}
        {showForm && (
          <form onSubmit={handleSubmit}>
            <Grid container alignItems="center" mt={3}>
              <Grid item lg={8} md={8} sm={6} xs={12}>
                <CustomFormLabel htmlFor="vehicle_no">
                  Vehicle Number <span style={{ color: "red" }}>*</span>
                </CustomFormLabel>
                <Autocomplete
                  id="vehicle_no"
                  name="vehicle_no"
                  options={vehicle_list}
                  // getOptionLabel={(option) => option.vehicle_no}
                  getOptionLabel={(option) =>
                    `${option.vehicle_no} - ${option.vehicle_name}`
                  }
                  value={
                    vehicle_list.find(
                      (vehicle_list) =>
                        vehicle_list.vehicle_no === values.vehicle_no
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "vehicle_no",
                        value: newValue?.vehicle_no || "",
                      },
                    });
                  }}
                  onBlur={handleBlur}
                  renderInput={(params) => (
                    <CustomTextField
                      {...params}
                      error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                      helperText={touched.vehicle_no && errors.vehicle_no}
                      fullWidth
                      variant="outlined"
                      placeholder="Search or select a vehicle"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                lg={4}
                md={4}
                sm={6}
                xs={12}
                mt={3}
                style={{
                  textAlign: "right",
                }}
              >
                <Button
                  color="success"
                  variant="contained"
                  type="submit"
                  style={{ marginLeft: 5 }}
                >
                  <IconCheck />
                </Button>
                <Button
                  color="error"
                  variant="contained"
                  onClick={handleCancel}
                  style={{ marginLeft: 5 }}
                >
                  <IconX />
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
        {/* ============================= */}
      </CardContent>
    </>
  );
};

export default AssignVehicle;
